import React, { useState } from 'react';
import { Check, Trash2 } from 'lucide-react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface AttendeePlaceholderRowProps {
  label: string;
  onComplete: (data: {
    firstName: string;
    lastName: string;
    email: string;
  }) => void;
  onRemove: () => void;
}

// Anonymous participant: filled in with the real data as soon as it arrives
export function AttendeePlaceholderRow({
  label,
  onComplete,
  onRemove
}: AttendeePlaceholderRowProps) {
  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [error, setError] = useState('');
  const save = () => {
    if (!data.firstName.trim() || !data.lastName.trim() || !data.email.trim()) {
      setError('Inserisci nome, cognome ed email personale');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(data.email.trim())) {
      setError("Inserisci un'email valida");
      return;
    }
    onComplete({
      firstName: data.firstName.trim(),
      lastName: data.lastName.trim(),
      email: data.email.trim()
    });
  };
  return <li className="px-4 py-3 bg-amber-50/40" data-id="element-1427" data-mp="1zhvfritvu54u">
      <div className="flex items-center justify-between gap-3 mb-2" data-id="element-1428" data-mp="24hraergowk7q">
        <span className="text-sm font-medium text-amber-800" data-id="element-1429" data-mp="299sw13zqznaf">{label}</span>
        <button type="button" onClick={onRemove} aria-label={`Rimuovi ${label}`} className="p-1.5 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors" data-id="element-1430" data-mp="29bvi5cxs4w9v">
          <Trash2 className="h-4 w-4" data-id="element-1431" data-mp="1ljezp1a4r2a1" />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1.3fr_auto] gap-3 items-start" data-id="element-1432" data-mp="1lm19l7khttvf">
        <Input aria-label={`Nome · ${label}`} placeholder="Nome" value={data.firstName} onChange={e => setData({
        ...data,
        firstName: e.target.value
      })} data-id="element-1433" data-mp="1ql4comgwxq0r" />
        <Input aria-label={`Cognome · ${label}`} placeholder="Cognome" value={data.lastName} onChange={e => setData({
        ...data,
        lastName: e.target.value
      })} data-id="element-1434" data-mp="320ayc2sndkms" />
        <Input aria-label={`Email personale · ${label}`} placeholder="Email personale" type="email" value={data.email} onChange={e => setData({
        ...data,
        email: e.target.value
      })} onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          save();
        }
      }} data-id="element-1435" data-mp="16wv0o499j32f" />
        <Button variant="flat" color="secondary" startContent={<Check className="h-4 w-4" data-id="element-1437" data-mp="j7ag5gxgnxr1" />} onClick={save} data-id="element-1436" data-mp="o2g1adj1h8e2">
          Salva
        </Button>
      </div>
      {error && <p className="text-xs text-red-600 font-medium mt-2" data-id="element-1438" data-mp="s65lyrwlf5tt">{error}</p>}
    </li>;
}